module.exports = __webpack_public_path__ + "static/media/covid19-popup-en-desktop.ee219399.png";